/**
 * The only sanctioned way to put a number on screen (§12.5 rules 1-2).
 *
 * It accepts an `Explained` envelope and nothing else — passing a raw `number` is a type error,
 * which is what keeps client-side arithmetic out of the UI. `display` is rendered verbatim;
 * `value` is never read here (it exists for chart geometry).
 */

import type { Explained } from '@lw/shared';
import { TooltipPopover } from './TooltipPopover';
import { cx } from './cx';

export type NumProps = {
  value: Explained<unknown>;
  /** Show the info affordance when the server attached a tooltip. Default `true`. */
  withTooltip?: boolean;
  /** Accessible name of the tooltip trigger. */
  tooltipLabel?: string;
  className?: string;
};

export function Num({ value, withTooltip = true, tooltipLabel, className }: NumProps) {
  return (
    <span className={cx('num-val', className)}>
      <span className="num-val__display">{value.display}</span>
      {withTooltip && value.tooltip ? (
        <TooltipPopover tooltip={value.tooltip} label={tooltipLabel} />
      ) : null}
    </span>
  );
}

export default Num;
